package pages.outbound

import ics.materialUI.components.classes.ContentFieldMapping

object OutboundListPageFieldMappings {
    val headerSequence: Array<String> = arrayOf(
        "recordId",
        "owner",
        "reference",
        "orderDate",
        "statusDescription",
        "amountToPick",
        "name",
        "address",
        "zipCode",
        "city",
        "country"
    )

    object FieldMappings {
        val english: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "recordId",
                "Record ID"
            ),
            ContentFieldMapping(
                "owner",
                "Owner"
            ),
            ContentFieldMapping(
                "reference",
                "Reference"
            ),
            ContentFieldMapping(
                "orderDate",
                "Order date"
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status description"
            ),
            ContentFieldMapping(
                "amountToPick",
                "Amount to pick"
            ),
            ContentFieldMapping(
                "name",
                "Name"
            ),
            ContentFieldMapping(
                "address",
                "Address"
            ),
            ContentFieldMapping(
                "zipCode",
                "Zipcode"
            ),
            ContentFieldMapping(
                "city",
                "City"
            ),
            ContentFieldMapping(
                "country",
                "Country"
            ),
        )
    }
}